import { mapActions } from 'vuex';
import { Confirmation } from '@/store/modules/confirm/Confirmation';
import * as Routes from '@/router/routes';

export const UnSavedMixin = {
    methods: {
        ...mapActions(['openConfirmDialog'])
    },
    beforeRouteLeave(to, from, next) {
        const isUnsaved = this.isDirty;
        if (isUnsaved && to.name !== Routes.LOGIN) {
            this.openConfirmDialog(new Confirmation(
                next,
                ' Are you sure you want to leave this page without saving changes?'
            ));
        }
        else {
            next();
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/UnSavedMixin.js